import axios from "axios";
import qs from 'qs'
import $store from "../store"
import $router from '../router'
import {ElMessage, ElLoading} from 'element-plus'


// let baseUrl =  'http://192.168.0.107:8000'
// let baseUrl =  'http://127.0.0.1:5025'
let baseUrl =  'http://api5.689988.com'
// let baseUrl = "http://103.93.46.13:8067"  //生产环境api地址
// let baseUrl = "https://study.xinango.cn"  //生产环境api地址
let imageUrl = baseUrl + '/'
let baseAPIUrl = baseUrl + '/api/'
axios.defaults.timeout = 50000
axios.defaults.baseURL = baseAPIUrl
axios.defaults.withCredentials = false

export function request(showLoading=false, url, method="get", params = {}){   
    let that = this
    // console.log(that)
    // that.$tpLoading()
    return new Promise((resolve, reject) => {
        let token = $store.state.token,
            headers = {
                'Authorization': token,
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        let timeout = 0
        // ElLoading
        if(showLoading){
            openLoading() 
            timeout = 100
        }
        setTimeout(function () {
            if(url.indexOf('http')===-1)
                url = baseAPIUrl + url
            if(method === 'upload'){
                method = 'post'
                headers['Content-Type'] = 'multipart/form-data'
            }
            axios.request({
                method: method.toLocaleUpperCase(), 
                url: url, 
                data:qs.stringify(params),
                headers: headers
            })
            .then(response => {
                if(showLoading) closeLoading()
                if(response.data.code === 1000){
                    resolve(response.data)
                }
                else if(response.data.code === 1002){
                    ElMessage.warning(response.data.msg)
                    $store.commit('EXIT')
                    $router.replace({path: '/login'})
                }
                else {
                    // console.log('fail', response.data.msg)
                    ElMessage.warning(response.data.msg)
                    resolve(false)
                }
            }, 
            err=>{
                console.log('err')
                if(showLoading) closeLoading()
                ElMessage.warning('请求失败~')
                reject(err)
                // that.$tpFail('reuqest fail~')
            })
            .catch(res=>{
                console.log(res)
                if(showLoading) closeLoading()
                console.log(res)
            }).finally(res=>{
                // that.$tpLoadend()
            })
        }, timeout)
    })
}

/**
 * post方法，对应post请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function postUpload(url, params = {}){
    return new Promise((resolve, reject) => {
        let token = $store.state.token
        axios.defaults.headers['Authorization'] = token  //token放在此处意味着可以实时读取最新的
        axios.defaults.headers['Content-Type'] = 'multipart/form-data'
        let timeout = 10
        setTimeout(function () {
            axios.post(url, params).then(response => {
                resolve(response.data)
            }, 
            err=>{
                reject(err)
                ElMessage.warning('请求失败~')
            })
            .catch(res=>{
                // console.log(res)
                ElMessage.warning('请求失败~')
            }).finally(res=>{
                // that.$tpLoadend()
            })
        }, timeout)
    })
}


export function download(showLoading=false, url, method="get", params = {}){
    return new Promise((resolve, reject) => {
        let token = $store.state.token,
            headers = {
                'Authorization': token,
                'Content-Type': 'application/x-www-form-urlencoded'
                // 'Content-Type': 'application/json',
                // 'Content-Disposition': 'attachment; filename="filename.extension"'
            }
        let timeout = 0
        if(showLoading){
            openLoading() 
            timeout = 50
        }
        setTimeout(function () {
            if(url.indexOf('http')===-1)
                url = baseAPIUrl + url
            axios.request({
                method: method.toLocaleUpperCase(), 
                url: url, 
                data:qs.stringify(params),
                headers: headers,
                responseType: 'blob'
            })
            .then(response => {
                // console.log(response)
                if(showLoading) closeLoading()
                if(response.data){
                    resolve(response.data)
                    let blob = new Blob([response.data], {
                        type: 'application/vnd.ms-excel'
                    })
                    let fileNameEncode = response.headers['content-disposition'].split("filename=")[1];
                    // 解码
                    let fileName = decodeURIComponent(fileNameEncode)
                    if (window.navigator.msSaveOrOpenBlob) {
                        navigator.msSaveBlob(blob, fileName)
                    } else {
                        var link = document.createElement('a')
                        link.href = window.URL.createObjectURL(blob)
                        link.download = fileName
                        link.click()
                        document.body.appendChild(link);
                        //释放内存
                        window.URL.revokeObjectURL(link.href)
                    }
                }
                else {
                    ElMessage.warning('download fail')
                    resolve(false)
                }
            }, 
            err=>{
                // console.log(err)
                if(showLoading){
                    closeLoading()
                }
                ElMessage.warning('请求失败~')
                reject(err)
                // that.$tpFail('reuqest fail~')
            })
            .catch(res=>{
                // ElMessage.warning('请求失败~')
                console.log('error', res)
            }).finally(res=>{
                // that.$tpLoadend()
                // console.log('finally')
            })
        }, timeout)
    })
}

export class Http{
	get(url, data={}, showLoading=false) {
		return request(showLoading, url, 'get', data)
	}
	post(url, data={}, showLoading=false) {
		return request(showLoading, url, 'post', data)
	}
	upload(url, data={}, showLoading=false) {
		// return request(showLoading, url, 'upload', data)
        return postUpload(url, data)
	}
	delete(url, data={}, showLoading=false) {
		return request(showLoading, url, 'delete', data)
	}
	put(url, data={}, showLoading=false) {
		return request(showLoading, url, 'put', data)
	}
	download(url, data={}, showLoading=false) {
		return download(showLoading, url, 'post', data)
	}
	apiurl(){
		return baseAPIUrl
	}
    imgurl(){
        return imageUrl
    }
    fileUrlTrans(url) {
        if (url.indexOf('http') === -1)
            url = baseUrl + '/' + url        
        return url
    }
}

let loading = null // loading
const openLoading = (text='请稍后...') => {
  loading= ElLoading.service({
    lock: true,
    text: text,
    background: 'rgba(0, 0, 0, 0.1)'
  })
}
const closeLoading = () => {
  loading.close()
}
